module.exports = __webpack_public_path__ + "static/img/qq_img_5.04de7787.png";